/* eslint-disable react-hooks/exhaustive-deps */
//@ts-nocheck
import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "userContext";

const useCheckTabActivityDetector = () => {
  const { beAdminUrl, isLocal } = window._env_;
  const navigate = useNavigate();
  const { setUser, user } = useContext(UserContext);

  const checkLogin = async () => {
    const res = await fetch(`${beAdminUrl}/bearer`, {
      method: "GET",
      credentials: "include",
      headers: isLocal
        ? {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        : {
            "Content-Type": "application/json",
          },
    });
    const result = await res.json();
    if (res.ok && result.data.status === "active") {
      if (!user) {
        setUser({
          firstName: result.data.profile.firstname,
          lastName: result.data.profile.lastname,
          primaryUname: result.data.primaryUname,
          ocrEnable:
            result.data.organizations[0].kvp.settings.enableOcrValuation,
          enablePopup:
            result.data.organizations[0].kvp.settings.enableShowFeedbackPopup,
        });
      }
    } else {
      navigate("/login", { replace: true });
    }
  };
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkLogin();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
};

export default useCheckTabActivityDetector;
